module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-section mt-32"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("첨부파일 등록")]), _vm._v(" "), _c('ul', {
    staticClass: "check-list"
  }, _vm._l((_vm.files), function(file) {
    return _c('li', {
      key: file.ATTCH_SEQ
    }, [_c('div', {
      staticClass: "tit"
    }, [_vm._v(_vm._s(file.ATTCH_FILE_INFO || file.FILE_INFO)), _c('br')]), _vm._v(" "), (file.REALFILENM !== null && file.REALFILENM !== '') ? _c('div', {
      staticClass: "file-input-wrapper"
    }, [(!_vm.isEditMode) ? _c('a', {
      style: ({
        cursor: file.REALFILENM ? 'pointer' : 'text'
      }),
      attrs: {
        "href": "javascript:void(0)",
        "title": "{{ file.REALFILENM || '-' }}"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(file)
        }
      }
    }, [_vm._v(_vm._s(file.REALFILENM || '-'))]) : _vm._e()]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a45d4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/AttachmentSection.vue
// module id = 1273
// module chunks = 6